<template>
  <div
    class="c-dropdown"
    :class="{
      'is-invalid': invalid,
      'w-full': fullwidth,
      disabled,
    }"
  >
    <select
      :id="id"
      :disabled="disabled"
      :value="modelValue"
      :class="{
        'form-select bg-white dark:bg-gray-700 sm:text-sm sm:leading-5 pl-3 pr-10 rounded-md': true,
        'w-full': fullwidth,
        'border-danger': invalid,
        'border-field border-gray-200 dark:border-gray-600': !invalid,
      }"
      @input="
        $emit(
          'update:modelValue',
          $event.target[$event.target.selectedIndex].value,
        );
        $emit('input', $event.target[$event.target.selectedIndex].value);
      "
    >
      <option
        v-for="option in options"
        :key="option.value"
        :value="option.value"
        :selected="option.value === modelValue"
      >
        {{ option.label }}
      </option>
    </select>
  </div>
</template>

<script setup lang="ts">
  withDefaults(
    defineProps<{
      disabled?: boolean;
      invalid?: boolean;
      fullwidth?: boolean;
      id?: string;
      options?: Array<{
        label: string;
        value: string;
      }>;
      modelValue?: number | string;
    }>(),
    {
      disabled: false,
      invalid: false,
      fullwidth: false,
      id: 'c-dropdown-id-' + Math.random().toString(36).substr(2, 9),
      options: () => {
        return [];
      },
      modelValue: '',
    },
  );

  defineEmits(['input', 'update:modelValue']);
</script>

<style lang="scss">
  .c-dropdown {
    display: inline-block;
    position: relative;

    &.disabled {
      @apply opacity-50;
    }

    select {
      background-position: right 0.5rem center;
    }
  }
</style>
